import React from 'react';

import CartMain from 'components/pages/cart/CartMain';

import { NextSeo } from 'next-seo';
import { getCartSeoProps } from 'router/seoprops';

const Cart = () => {
	const seoProps = getCartSeoProps();

	return (
		<>
			<NextSeo {...seoProps} />
			<CartMain />
		</>
	);
};

export default Cart;
